import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "signinPanel", "signupPanel", "signinTab", "signupTab", "backdrop"]

  connect() {
    this._onKeydown = this._onKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  openSignin(event) {
    event?.preventDefault()
    this._show("signin")
  }

  openSignup(event) {
    event?.preventDefault()
    this._show("signup")
  }

  close(event) {
    event?.preventDefault()
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeBackdrop(event) {
    if (event.target === this.backdropTarget) {
      this.close()
    }
  }

  switchToSignin(event) {
    event?.preventDefault()
    this._activateTab("signin")
  }

  switchToSignup(event) {
    event?.preventDefault()
    this._activateTab("signup")
  }

  _show(tab) {
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this._activateTab(tab)
  }

  _activateTab(tab) {
    const isSignin = tab === "signin"
    this.signinPanelTarget.classList.toggle("hidden", !isSignin)
    this.signupPanelTarget.classList.toggle("hidden", isSignin)

    const activeTab = "border-b-2 border-primary-600 text-primary-600 font-semibold"
    const inactiveTab = "text-gray-500 hover:text-gray-700"

    if (isSignin) {
      this.signinTabTarget.className = `flex-1 py-3 text-sm text-center cursor-pointer ${activeTab}`
      this.signupTabTarget.className = `flex-1 py-3 text-sm text-center cursor-pointer ${inactiveTab}`
    } else {
      this.signinTabTarget.className = `flex-1 py-3 text-sm text-center cursor-pointer ${inactiveTab}`
      this.signupTabTarget.className = `flex-1 py-3 text-sm text-center cursor-pointer ${activeTab}`
    }
  }

  _onKeydown(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
